import { getAuth } from 'firebase/auth';
import type { Auth } from 'firebase/auth';
import type { FirebaseStorage, ListResult, StorageReference, UploadResult } from 'firebase/storage';
import { getDownloadURL, getStorage, listAll, ref, uploadString } from 'firebase/storage';
import { ImageActionType } from '../constant/ActionConstant';
import AppDispatcher from '../dispatcher/AppDispatcher';

class ImageActionCreators {

    async fetchCurrentImageBucket(): Promise<void> {
        const auth = getAuth()
        const uid = auth.currentUser?.uid
        if (!uid) {
            throw new Error('No firebase User');
        }
        const storage: FirebaseStorage = getStorage()
        const storageReference: StorageReference = ref(storage, 'images/' + uid)
        const allData: ListResult = await listAll(storageReference)
        allData.items.forEach(async (file: StorageReference) => {
            const url = await getDownloadURL(file);
            AppDispatcher.dispatch({
                'type': ImageActionType.ADD_IMAGE_URL,
                'data': url
            });
        });
    }

    async addImageToBucket(files: FileList): Promise<string> {
        const auth: Auth = getAuth()
        const uid: string | undefined = auth.currentUser?.uid
        if (!uid) {
            throw new Error('No firebase User');
        }
        const storage: FirebaseStorage = getStorage()
        const storageReference: StorageReference = ref(storage, 'images/' + uid + '/' + files[0].name)
        const uploadedFile: UploadResult = await uploadString(storageReference, files[0].name)

        const url = await getDownloadURL(uploadedFile.ref);
        AppDispatcher.dispatch({
            'type': ImageActionType.ADD_IMAGE_URL,
            'data': url
        });
        return url;
    }
}

const imageActionCreator = new ImageActionCreators();
export default imageActionCreator;